import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; 
import "./App.css";
import Hero from './images/illustration-features-tab-2.svg';

const FeaturesTab2 = () => {
    return (
        <main className='main-fs'>
            <div className="second-section">
                <img src={Hero} />
            </div>
            <div className='first-section fs'>
                <h1>Intelligent search</h1>
                <p>Our powerful search feature will help you find saved sites in no time at all. 
                No need to trawl through all of your bookmarks.</p>
                <button className='btn1'>
                    More Info
                </button>
            </div>
            
        </main>
    );
}

export default FeaturesTab2;
